import React, { useState } from "react";
import secureAxios from "../../utils/secureAxios";
import LocationList from "./LocationList";
import CreateLocationForm from "./CreateLocationForm";
import EditLocationForm from "./EditLocationForm";

const LocationPage = () => {
  const [activeTab, setActiveTab] = useState("list");
  const [editingLocation, setEditingLocation] = useState(null);

  const handleEdit = async (location) => {
    try {
      const res = await secureAxios.get(
        `/api/locations/${location.location_id}`
      );
      setEditingLocation(res.data);
    } catch (err) {
      console.error("❌ Failed to fetch full location details:", err);
      alert("❌ Could not load location details for editing.");
    }
  };

  const handleEditCancel = () => {
    setEditingLocation(null);
    setActiveTab("list");
  };

  return (
    <div className="container-fluid">
      <h3>Locations</h3>

      {/* Tabs only visible if not editing */}
      {!editingLocation && (
        <ul className="nav nav-tabs mb-3">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "list" ? "active" : ""}`}
              onClick={() => setActiveTab("list")}
            >
              📋 Location List
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "create" ? "active" : ""}`}
              onClick={() => setActiveTab("create")}
            >
              ➕ Create Location
            </button>
          </li>
        </ul>
      )}

      {/* Display logic */}
      <div>
        {editingLocation ? (
          <EditLocationForm
            location={editingLocation}
            onCancel={handleEditCancel}
            onUpdated={handleEditCancel} // optional refresh handler
          />
        ) : activeTab === "list" ? (
          <LocationList onEdit={handleEdit} />
        ) : (
          <CreateLocationForm onSuccess={() => setActiveTab("list")} />
        )}
      </div>
    </div>
  );
};

export default LocationPage;
